module.exports = __webpack_public_path__ + "img/BH.0dc78a04.svg";